import axios from 'axios'

export default {
    async fetchById(id) {
        return await axios.get(`activity-type-role/${id}`)
    },
}
